import React from "react";
import Typist from 'react-typist';
import 'react-typist/dist/Typist.css'
import messages from '../components/messages';
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import first from "../assets/images/assessment/1.png"
import second from "../assets/images/assessment/2.png"
import third from "../assets/images/assessment/3.png"
import fourth from "../assets/images/assessment/4.png"
import fifth from "../assets/images/assessment/5.png"

const Index = props => {
  return (
      <div className="c-content-box">
        <h2>Seismic Assessment</h2>
          <div style={{ textAlign: 'justify', lineHeight: '2em'}}>

          <img src={first} style={{ width: '100%', height: '100%' }} />

          In the last years, my work has been related to seismic vulnerability assessment. This is often related to existing structures which typically are not designed to resist earthquakes. It is commonly accepted that seismic assessment is not a prediction of the actual performance of a structure under a particular seismic attack but instead is the general understanding of the likely behaviour of the structure under a certain level of the seismic demand. <br /> <br />

          <h3>In a few words...</h3>
          In simple terms, for a given the intensity of the earthquake demand, the purpose of seismic assessment is to assign a “score” to the examined structure in relation, but not limited, to its ability to preserve human life (called life safety performance objective). This is usually carried out according to a national or internationa standard. <br /> <br />

          <img src={second} style={{ width: '100%', height: '100%' }} />
          <img src={third} style={{ width: '100%', height: '100%' }} />
          <img src={fourth} style={{ width: '100%', height: '100%' }} />

          <h3>Analysis techniques</h3>
          This can be done with different analysis techniques with different levels of refinement. The Linear Static and Linear Dynamic analyses are particularly simple and fast to perform but are limited to the elastic range (i.e. they cannot explicitly predict damage). On the other hand, Non-Linear analyses (static or dynamic) are more accurate and more onerous. The most advanced one is the Non-Linear Dynamic analysis (also called time history), which allows to predict the behaviour of the structure under a recorded or simulated ground motion. However, due to the main difficulties related to the time history, the mostly-adopted analysis technique is the Non-Linear Static (or pushover). In this case, the structure is pushed with forces to calculate its maximum capacity in terms of forces and, more importantly, in terms of displacements.

          See the section about <a target="_blank" href="http://robswebdemo.hopto.org:8000/modeling">numerical modeling</a> to see some foto/video example of analysis. <br /> <br />

          <img src={fifth} style={{ width: '100%', height: '100%' }} />

        </div>
      </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/assessment.en.jsx